module.exports = __webpack_public_path__ + "static/img/order-success-icon.7a543aaa.png";